// extracted by mini-css-extract-plugin
export default {"mainLayout":"Layout_mainLayout__1arXU","mainContentBox":"Layout_mainContentBox__A5rev","mainContent":"Layout_mainContent__4J0iz"};